import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import {SwalAlertClass} from "core/swalClass";
import {ProgrammingModel} from "site-apps/distribution/programming/ProgrammingModel";
import FormTabProgramming from "./FormTabProgramming";
import FormTabRoutes from "./FormTabRoutes";
import FormTabFleet from "./FormTabFleet";
import {updateListById} from "core/utils/arrays";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";

const FormProgramming = ({
    show,
    setShow,
    item = {...ProgrammingModel},
    items,
    setItemsShow,
}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: tR} = useTranslation("routes");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [keyTab, setKeyTab] = useState("programming");
    const [days, setDays] = useState([]);
    const [optionsShown, setOptionsShown] = useState([]);
    const [option, setOption] = useState("0");
    const [thing, setThing] = useState({...item});
    const [routes, setRoutes] = useState([]);
    const inputRefs = useRef({
        name: null,
        date_start: null,
        hour_start: null,
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setOption("0");
        setOptionsShown([]);
        setDays([]);
        setRoutes(item.routeslst);
    }, [item]);

    const handleClose = () => setShow(false);

    const handleSubmit = () => {
        setKeyTab("programming");
        if (!thing.name) {
            Alert.warning("Falta dato obligatorio", "Es necesario un Nombre").then(
                () => {
                    inputRefs.current.name.focus();
                }
            );
            return;
        } else if (!thing.date_start) {
            Alert.warning("Falta dato obligatorio", "Es necesario la Fecha de inicio");
            return;
        } else if (!thing.compile) {
            Alert.warning(
                "Falta dato obligatorio",
                "Es necesario la Hora de programación"
            );
            return;
        } else if (!thing.run) {
            Alert.warning("Falta dato obligatorio", "Es necesario la Hora de la ruta");
            return;
        }

        setIsLoading(true);
        let dataSend = {...thing};
        // eliminar segundos de TIME
        if (dataSend.compile.includes(":")) {
            dataSend.compile = dataSend.compile.split(":").slice(0, 2).join(":");
        }
        if (dataSend.run.includes(":")) {
            dataSend.run = dataSend.run.split(":").slice(0, 2).join(":");
        }
        switch (dataSend.repeat) {
            case "w":
                dataSend.values = [...days];
                break;
            case "m":
            case "y":
                dataSend.values = optionsShown.find((item) => item.id === option);
                break;

            default:
        }
        dataSend.routes = [];
        (routes || []).forEach((route) => {
            dataSend.routes.push({
                id: route.id || "",
                type: route.type,
                route_id: route.item.id,
                requires: route.requires || {},
                truck_id: route.truck_id || null,
                driver_id: route.driver_id || null,
            });
        });
        axiApi
            .post(`/api/distribution/programming/`, dataSend)
            .then((resp) => {
                if (resp.data.status) {
                    if (dataSend.id) {
                        items.current.all = updateListById(
                            items.current.all,
                            resp.data.item
                        );
                        items.current.showed = updateListById(
                            items.current.showed,
                            resp.data.item
                        );
                    } else {
                        items.current.all.push(resp.data.item);
                        items.current.showed.push(resp.data.item);
                    }
                    setItemsShow([...items.current.showed]);
                    setShow(false);
                    Alert.info("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.error("Error al guardar", resp.data.message);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
    };

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                style={{width: "40%", fontSize: "15px"}}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="clipboard" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{tR("labels.programming")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                    <div className="col-12">
                        <Tabs
                            activeKey={keyTab}
                            id="form-programming-tabs"
                            onSelect={(k) => setKeyTab(k)}
                            className="mb-3 mt-1"
                            justify>
                            <Tab
                                eventKey="programming"
                                title={tR("labels.programming")}>
                                <FormTabProgramming
                                    thing={thing}
                                    setThing={setThing}
                                    days={days}
                                    setDays={setDays}
                                    optionsShown={optionsShown}
                                    setOptionsShown={setOptionsShown}
                                    option={option}
                                    setOption={setOption}
                                    inputRefs={inputRefs}
                                />
                            </Tab>
                            <Tab eventKey="routes" title={tR("labels.routes")}>
                                <FormTabRoutes routes={routes} setRoutes={setRoutes} />
                            </Tab>
                            <Tab eventKey="fleet" title={tR("labels.fleet")}>
                                <FormTabFleet routes={routes} setRoutes={setRoutes} />
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="p-3 buttons-footer">
                        <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}>
                                {_Tf("labels.cancel")}
                            </button>
                            {/* <button type="button" className="btn btn-primary ms-4"
                                onClick={handleSubmit}
                            >
                                {_Tf("labels.save")}
                            </button> */}
                            <FormButton
                                label="Guardar"
                                className="btn btn-primary ms-4"
                                isProcessing={isLoading}
                                onClick={handleSubmit}>
                                {_Tf("labels.save")}
                            </FormButton>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormProgramming;
